import React, {useState} from 'react';

export const CambiarContraseña = (props) => {
	const {cambioContraseña, confirmacionContraseña} = props;

	const [contrasenas, setContrasenas] = useState({
		contrasena: '',
		confirmarContrasena: '',
	});

	const onInputChange = (e) => {
		const {name, value} = e.target;
		setContrasenas({...contrasenas, [name]: value});
	};

	return (
		<div className='ContentOlvContraseña'>
			<div className='text-center fw-semibold fs-5'>¿Ha olvidado su contraseña?</div>
			<div className='centrador'>Introduzca la nueva contraseña.</div>
			<div className='inputCorreoOlvidarContraseña'>
				{!confirmacionContraseña && (
					<div className='centrador correroInvalido'>Las constraseña no coinciden</div>
				)}
				<label htmlFor="" className='fw-bold'>Nueva contraseña:</label>
				<input
					type='password'
					placeholder='Nueva contraseña'
					className='form-control text-dark'
					value={contrasenas.contrasena}
					name='contrasena'
					onChange={onInputChange}
				/>
				<small className="text-muted">
					La contraseña debe tener al menos 6 caracteres, una mayúscula, una minúscula y un número.
				</small>
			</div>
			<div className='inputCorreoOlvidarContraseña'>
				<label htmlFor="" className='fw-bold'>Repita la contraseña:</label>
				<input
					type='password'
					placeholder='Repita la contraseña'
					className='form-control text-dark'
					value={contrasenas.confirmarContrasena}
					name='confirmarContrasena'
					onChange={onInputChange}
				/>
			</div>
			<div className=''>
				<button
					className='btn login-boton w-full'
					onClick={() => cambioContraseña(contrasenas)}
				>
					<b>Cambiar contraseña</b>
				</button>
			</div>
		</div>
	);
};
